console.log('sso.js');

$('.input-validation input').on('keypress keyup blur', function (event) {
    $(this).val(
        $(this)
            .val()
            .replace(/[^\d].+/, '')
    );
    if (event.which < 48 || event.which > 57) {
        event.preventDefault();
    }
});

$('.input-validation input').on('keyup', function (event) {
    if ($(this).index() < 6) {
        if (event.keyCode == 46 || event.keyCode == 8) {
            $(this).prev('input').focus();
        } else {
            if (
                (event.keyCode >= 96 && event.keyCode <= 105) ||
                (event.keyCode >= 48 && event.keyCode <= 57)
            ) {
                $(this).next('input').focus();
            }
        }
    }
});

$('.notification')
    .find('button.close')
    .on('click', function () {
        $(this).closest('.notification').addClass('hide');
    });



// WEBPACK FOOTER //
// ./js/sso.js